import jwtDecode from 'jwt-decode'
import { useQuery, type OperationVariables } from '@apollo/client'

import { AccessToken, Locale } from '@/types'
import { batchClient } from '@/components/App/client'
import { LOGGED_IN_EMPLOYEE_QUERY } from '@/graphql/queries/Employee'
import type { LoggedInEmployeeQuery } from '@/gql/graphql'

type NonNullableFields<T> = {
  [K in keyof T]-?: NonNullable<T[K]>
}

type UserById = NonNullable<LoggedInEmployeeQuery['userById']>

type Company = NonNullable<NonNullableFields<UserById['company']>>

interface ReturnData extends Omit<UserById, 'company' | 'locale'> {
  userId: string
  originalUserId: string
  companyId: string
  userScope: any
  loading: boolean
  locale: Locale
  company: Company
  departmentIds: string[]
}

const useLoggedInUser = (
  loadData = false,
  queryOptions?: OperationVariables,
) => {
  const {
    id: userId = null,
    employeeId = null,
    companyId = null,
    locale = null,
    originalUserId = null,
  } = sessionStorage.getItem('accessToken')
    ? jwtDecode<AccessToken>(sessionStorage.getItem('accessToken') as string)
        .user
    : {}

  const userScope = JSON.parse(sessionStorage.getItem('userScope') as string)

  const { data = {}, loading } = useQuery(LOGGED_IN_EMPLOYEE_QUERY, {
    variables: { id: userId ?? '' },
    skip: !loadData || !(userId || queryOptions?.variables?.id),
    ...queryOptions,
    client: batchClient,
  })

  return {
    userId: userId ?? '',
    originalUserId: originalUserId ?? '',
    employeeId: employeeId ?? '',
    companyId: companyId ?? '',
    locale: locale ?? '',
    userScope: userScope,
    ...(data?.userById ?? {}),
    loading: loading,
    company: data?.userById?.company ?? {},
    departmentIds: data?.userById?.departments ?? [],
  } as ReturnData
}

export default useLoggedInUser
